<div class="container-fluid full-page-height">
    <div class="row">
        <div class="col-12">
            <h5 class="cursor d-flex align-items-center mb-0">
                <u routerLink='#' (click)="navToHome()">{{ 'Home' | translate }}</u>
            </h5>

            <h2 class="d-flex mb-16 align-items-center mt-0">
                <mat-icon matTooltip="Click here to go Home" routerLink="#" (click)="navToHome()" class="arrow-icon-left cursor"
                    svgIcon="Back"></mat-icon>

                <span class="facility">{{ 'BulkActivationTitle' | translate }}</span>
            </h2>
        </div>
    </div>
    <!-- Form to capture CSV data along with batch and lot details -->
    <app-bulk-csv-form></app-bulk-csv-form>

    <!-- TODO: Remove the below section after UAT confirmation-->
    <!-- <mat-card class="p-4 mat-class">
        <div class="row" class="mr-10">
            <p class="para">
                {{'bulkActivationTitleText'|translate}}
            </p>
        </div>

        <br><br>

        <div class="row" *ngIf="!FileUploadStatus == true && initialView == true">
            <div class="col-6">
                <label style="font-size:18px;">{{'SelectCSV'|translate}}</label>
            </div>
            <div class="col-6" style="text-align: end;">
                <a href="https://storagedhhpsitau.blob.core.windows.net/applicationassets/bulk-wu-serials-template.csv"
                    download="Bulk QR Activation - template.csv" matTooltip="{{'CSVFileTooltip'|translate}}">
                    {{'BulkTemplateFile'|translate}}
                    <img class="assets-icon usermgt-icon material-icons ml-2"
                        src="assets/img/svg/ms-excel-csv-icon.svg" />
                </a>
            </div>
        </div>

        <div class="dropzone" appDnd (fileDropped)="onFileDropped($event)"
            *ngIf="!FileUploadStatus == true && initialView == true">
            <div class="col-12" style="height: 100%;">
                <div class="row" style="height: 100%;">
                    <div class="col-12 center-text">
                        <input type="file" #fileDropRef id="fileDropRef"
                            (change)="fileBrowseHandler($event.target.files)" accept=".csv" />
                        <label for="fileDropRef">
                            <img class="assets-icon usermgt-icon material-icons"
                                src="assets/img/svg/upload-file-icon.svg" />
                        </label>
                        <p style="font-size: 16px;"><strong>{{'SelectCSVFile'|translate}}</strong></p>
                        <p for="fileDropRef" style="font-size: 14px;">{{'or'|translate}} {{'DragAndDropHere'|translate}}
                        </p>
                    </div>
                </div>
            </div>
        </div>

        <div class="col-12 ">
            <div *ngIf="!showProgress == true && FileUploadStatus == true" class="center-content">
                <img src="assets/img/svg/uploaded_file.svg" alt="file" />
                <h4 class="name">
                    {{filename}}
                </h4>
                <p class="size">
                    {{getCorrectSize(fileSize)}}
                </p>
            </div>

            <div *ngIf="showProgress == true && FileUploadStatus == true" class="center-content">
                <div class="progress-pie-chart" data-percent="{{progress}}">
                    <div class="ppc-progress">
                        <div class="ppc-progress-fill"></div>
                    </div>
                    <div class="ppc-percents">
                        <div class="pcc-percents-wrapper">
                            <span>%</span>
                        </div>
                    </div>
                </div>
                <br />
                <button [disabled]='cancelActive' mat-raised-button color="accent" (click)="clickedCancel()"
                    matTooltip="{{'Cancel'|translate}}">{{"Cancel"|translate}}
                </button>
            </div>
        </div>
    </mat-card> -->
    <!-- <div class="mat-class" *ngIf="!showProgress == true && FileUploadStatus == true"
        class="form-group float-right mb-10 mt-30 cancel">

        <button mat-raised-button color="accent" style="margin: 10px;" (click)="goBack()"
            matTooltip="{{'Back'|translate}}">{{'Back'|translate}}</button>
        <button mat-raised-button color="primary" style="margin: 10px;" (click)="loadProceed()"
            matTooltip="{{'Proceed'|translate}}">{{'Proceed'|translate}}</button>
    </div> -->
</div>